import { createContext, type PropsWithChildren, useContext } from 'react';
import type { AuthInfo } from '../hook/model/authInfo.ts';

type Account = AuthInfo.Account;

const AccountContext = createContext<Account | undefined>(undefined);

type Res = {
  account: Account;
  isSystemAdmin: boolean;
};

export const useAccount = (): Res => {
  const account = useContext(AccountContext);

  if (!account) throw new Error('AccountProvider is not found');

  return { account, isSystemAdmin: account.hasActiveSystemAdmin };
};

export const AccountProvider: React.FC<PropsWithChildren<{ account: Account }>> = ({ account, children }) => {
  return <AccountContext.Provider value={account}>{children}</AccountContext.Provider>;
};
